/**
 * Track a custom event in Google Analytics 4.
 * Fail-safe — if GA is blocked or not loaded, silently does nothing.
 *
 * @param {string} eventName - Event name (snake_case, e.g., 'booking_complete')
 * @param {object} params - Optional event parameters
 */
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, params);
    }
  } catch (e) {
    // Silently fail — analytics should never break the app
  }
}

/**
 * Track a page view (for SPA navigation).
 * Call this in the router or on route changes.
 *
 * @param {string} path - The page path (e.g., '/dashboard', '/my-sessions')
 * @param {string} title - Optional page title
 */
export function trackPageView(path, title) {
  try {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-EQT8QPY2WT', {
        page_path: path,
        page_title: title || document.title,
      });
    }
  } catch (e) {
    // Silently fail
  }
}
